import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { BoltFillIcon, LockFillIcon } from '@/icons';
import { upsellingModal } from '@/shared/components/UpsellingModal';
import { useUserPlanManager } from '@/shared/plan';
import { type PlanType } from '@/types';
import { type MapTemplate } from '@/types/MapTemplate';
import { Button } from '@/ui_v3';
import { cn } from '@/utils';
interface Props {
  className?: string;
  map: MapTemplate;
  isChange?: boolean;
  onSubmit?: (map: MapTemplate) => void;
}
export const MapTemplateSubmitAction = ({
  className,
  map,
  isChange = false,
  onSubmit
}: Props) => {
  const {
    t
  } = useTranslation(['build', 'common']);
  const {
    userPlanManager
  } = useUserPlanManager();
  const needPlanUpgrade = !userPlanManager.hasEnoughPlanType(map.templatePlanType);
  const handleSubmit = () => {
    if (needPlanUpgrade) {
      upsellingModal.open({
        initialPlanType: map.templatePlanType as Exclude<PlanType, 'FREE'>,
        from: 'paidMap'
      });
      return;
    }
    onSubmit?.(map);
  };
  return <div className={cn('flex flex-col items-center gap-2xs', className)} data-sentry-component="MapTemplateSubmitAction" data-sentry-source-file="MapTemplateSubmitAction.tsx">
      {needPlanUpgrade && <div className="flex items-center gap-2xs text-assistive">
          <LockFillIcon size="xs" />
          <p className="text-body-sm-semibold">
            {t('build:mapTemplate.cannotSelectMapNow')}
          </p>
        </div>}
      <Button className={cn('w-full', needPlanUpgrade && (map.templatePlanType === 'BASIC' ? 'bg-gradient-mint-green' : 'bg-gradient-violet-blue'))} leftSlot={needPlanUpgrade ? <BoltFillIcon size="md" fill={ICON_COLOR.inverse} /> : undefined} onClick={handleSubmit} data-sentry-element="Button" data-sentry-source-file="MapTemplateSubmitAction.tsx">
        {needPlanUpgrade ? t('build:mapTemplate.upgradePlanToSelectMap') : isChange ? t('common:global.change.button') : t('build:build.mapTemplateModal.createQuiz')}
      </Button>
    </div>;
};